export enum UserRole {
  SITE = 'Sito',
  CER = 'Cer',
  ADMIN = 'Admin',
  INTRAPRESA = 'Intrapresa',
}
